// Constants
import { LOGGING_ACTION_TYPE, MONITOR_ATTR } from './monitoringConstants';

/**
 * An action that can be used to track certain operations via New Relic.
 */
export const monitorLogAction = ({ user, operation, ...rest }) => ({
    type: LOGGING_ACTION_TYPE,
    monitoring: {
        [MONITOR_ATTR.OPERATION]: operation,
        ...rest,
    },
    user,
});
